import React from 'react';
import { ArrowUpRight, ArrowDownRight, Info } from 'lucide-react';

/**
 * Single KPI tile used at the top of dashboard / performance / payouts pages.
 *
 * Props:
 *   - label, value (string)            required
 *   - delta (number) — pct change; omitted hides the delta row
 *   - deltaLabel (string) — defaults to "vs last month"
 *   - tooltip (string)
 *   - icon (lucide component)
 *   - testid (string)
 */
export const KpiCard = ({ label, value, delta, deltaLabel = 'vs last month', tooltip, icon: Icon, testid = 'kpi-card' }) => {
  const positive = typeof delta === 'number' && delta >= 0;
  const showDelta = typeof delta === 'number' && Number.isFinite(delta);
  return (
    <div
      className="bg-white border border-gray-200 rounded-xl p-5 shadow-[0_2px_8px_-2px_rgba(0,0,0,0.04)] flex flex-col gap-3"
      data-testid={testid}
    >
      <div className="flex items-center justify-between text-xs font-medium text-gray-500">
        <span className="inline-flex items-center gap-1.5">
          {Icon && <Icon className="w-3.5 h-3.5 text-gray-400" />}
          {label}
        </span>
        {tooltip && (
          <span title={tooltip} className="text-gray-400 cursor-help">
            <Info className="w-3.5 h-3.5" />
          </span>
        )}
      </div>
      <div className="text-[28px] font-bold tracking-tight text-gray-900 leading-none">{value}</div>
      {showDelta && (
        <div className="text-xs text-gray-500 flex items-center gap-1.5">
          <span
            className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded font-medium ${
              positive ? 'text-emerald-600 bg-emerald-50' : 'text-rose-600 bg-rose-50'
            }`}
          >
            {positive ? <ArrowUpRight className="w-3 h-3" /> : <ArrowDownRight className="w-3 h-3" />}
            {Math.abs(delta).toFixed(1)}%
          </span>
          <span>{deltaLabel}</span>
        </div>
      )}
    </div>
  );
};

export default KpiCard;
